class Utils {
  static isObject(val) {
    return typeof val === 'object' && val !== null
  }

  static createCustomEvent({ type, data } = {}) {
    return new CustomEvent(type, { detail: data });
  }

  static string = {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }

  static number = {
    toMoney: (value) => {
      //TODO: see if this instance can be moved out of this block
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return formatter.format(value)
    }
  }
}
